export const showNotification= (message,actionWord,actionType,button) => ({ type: 'SHOW_NOTIFICATION',message,actionWord,actionType,button})
export const hideNotification= () => ({ type: 'HIDE_NOTIFICATION'})

// button={
// 	buttonLabel:"stuff",
// 	buttonAction:function
// }